import React, { useEffect, useRef } from 'react';

// Imported directly (not via components/index.js): only request listings use it.
import RequestPrivateDetails from '../../components/RequestPrivateDetails/RequestPrivateDetails';

import RequestEditForm from './RequestEditForm/RequestEditForm';

/**
 * A request's private details, or the edit form while the homeowner is editing (the
 * "Edit request" button is in the bar at the top of the page, PicksSummary). After
 * saving, the page reloads so the title, answers, description and photos all show the
 * saved version.
 *
 * @param {Object} props
 * @param {Object} props.requestDetails from useRequestDetails
 * @param {Object} props.listing the request listing
 * @param {Array<Object>} props.listingFieldConfigs config.listing.listingFields
 * @param {boolean} props.editing show the edit form
 * @param {Function} props.onStopEditing close the edit form
 * @returns {JSX.Element}
 */
const SectionRequestDetails = props => {
  const { requestDetails, listing, listingFieldConfigs, editing, onStopEditing } = props;
  const formRef = useRef(null);
  const canEdit = requestDetails.status === 'loaded' && requestDetails.details?.canEdit;
  const showForm = editing && canEdit;

  // The button is at the top of the page; bring the form into view when it opens.
  useEffect(() => {
    if (showForm && formRef.current?.scrollIntoView) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [showForm]);

  if (showForm) {
    return (
      <div ref={formRef}>
        <RequestEditForm
          listing={listing}
          details={requestDetails.details}
          listingFieldConfigs={listingFieldConfigs}
          onSaved={() => typeof window !== 'undefined' && window.location.reload()}
          onCancel={onStopEditing}
        />
      </div>
    );
  }

  return <RequestPrivateDetails state={requestDetails} />;
};

export default SectionRequestDetails;
